import { z } from 'zod';
import { MapEntity, mapEntitySchema } from 'app/agriculture/queries/types/geometry/MapEntity';
import {
    mockPointGeometry,
    PointGeometry,
    pointGeometrySchema,
} from 'app/agriculture/queries/types/geometry/PointGeometry';

export interface CoolRoom extends MapEntity {
    id: string;

    creatorId: number;
    createdAt: Date;
    updatedAt: Date;

    name: string;

    geometry: PointGeometry;
}

export const coolRoomSchema = mapEntitySchema.extend({
    id: z.string().uuid(),

    creatorId: z.number(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),

    name: z.string(),

    geometry: pointGeometrySchema,
});

export const mockCoolRoom = ({
    id = 'a6377d7b-a329-479d-9236-a77b66530eb0',

    creatorId = 1,
    createdAt = new Date(),
    updatedAt = new Date(),

    name = 'Mock Cool Room Name',

    geometry = mockPointGeometry(),
}: Partial<CoolRoom> = {}): CoolRoom => ({
    id,

    creatorId,
    createdAt,
    updatedAt,

    name,

    geometry,
});
